import _toConsumableArray from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.number.constructor.js";
import { getAUOOverviewApi, getAUOPlantInvertersApi } from '@/api/otherSources';

import dayjs from 'dayjs';
var LEVEL_ORDER = {
  fault: 0,
  warn: 1,
  info: 2
};
export default {
  name: 'AUOPanel',
  data: function data() {
    return {
      loading: false,
      plants: [],
      errors: [],
      fetchedAt: null,
      stale: false,
      opened: {},
      detail: {},
      detailLoading: {},
      detailError: {}
    };
  },
  computed: {
    fetchedAtText: function fetchedAtText() {
      return this.fetchedAt ? dayjs(this.fetchedAt).format('MM/DD HH:mm') : '';
    },
    allAlerts: function allAlerts() {
      return this.plants.flatMap(function (p) {
        return p.alerts.map(function (a) {
          return _objectSpread(_objectSpread({}, a), {}, {
            plantName: p.name
          });
        });
      }).sort(function (a, b) {
        return LEVEL_ORDER[a.level] - LEVEL_ORDER[b.level];
      });
    },
    faultCount: function faultCount() {
      return this.countLevel('fault');
    },
    warnCount: function warnCount() {
      return this.countLevel('warn');
    },
    infoCount: function infoCount() {
      return this.countLevel('info');
    },
    kpis: function kpis() {
      var p = this.plants[0] || {};
      return [{
        label: '今日發電',
        value: this.fmt(p.energyToday, 1),
        unit: ' kWh',
        tone: '',
        hint: this.energyHint(p)
      }, {
        label: '即時總發電功率',
        value: this.fmt(p.instantPower, 1),
        unit: ' kW',
        tone: ''
      }, {
        label: '等效小時',
        value: this.fmt(p.yieldToday, 2),
        unit: ' h',
        tone: ''
      }, {
        label: '今日 PR',
        value: p.prToday == null ? 'NA' : this.fmt(p.prToday, 1),
        unit: p.prToday == null ? '' : '%',
        tone: p.prToday != null && p.prToday < 70 ? 'is-warn' : ''
      }, {
        label: '目前日照',
        value: p.irradianceNow == null ? '—' : p.irradianceNow,
        unit: ' W/m²',
        tone: ''
      }, {
        label: '故障（紅燈）',
        value: this.faultCount,
        unit: ' 件',
        tone: this.faultCount ? 'is-fault' : ''
      }];
    }
  },
  methods: {
    // 樣板裡的 dayjs 是查 this 的，而模組層那個是 webpack ProvidePlugin 注入的，
    // 兩者不通 —— 沒掛這一行，告警明細那一列會炸 render，整張展開卡片都出不來
    dayjs: dayjs,
    countLevel: function countLevel(level) {
      return this.allAlerts.filter(function (a) {
        return a.level === level;
      }).length;
    },
    /** 今日發電是「當日最後一筆累計 − 第一筆」，起算時間要在畫面上講明白 */energyHint: function energyHint(p) {
      var from = p.windowStart ? dayjs(p.windowStart).format('HH:mm') : '—';
      return "\u7531\u9010\u53F0\u7D2F\u8A08\u96FB\u91CF\u76F8\u6E1B\u8A08\u7B97\uFF0C\u81EA\u4ECA\u65E5 ".concat(from, " \u8D77\u7B97");
    },
    load: function load() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _yield$getAUOOverview, data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loading = true;
                _context.prev = 1;
                _context.next = 4;
                return getAUOOverviewApi();
              case 4:
                _yield$getAUOOverview = _context.sent;
                data = _yield$getAUOOverview.data;
                _this.plants = data.plants;
                _this.errors = data.errors;
                _this.fetchedAt = data.fetchedAt;
                _this.stale = data.stale;
                _this.detail = {};
                _context.next = 16;
                break;
              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](1);
                _this.errors = [{
                  msg: '資料讀取失敗，請洽資訊人員'
                }];
              case 16:
                _context.prev = 16;
                _this.loading = false;
                return _context.finish(16);
              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 13, 16, 19]]);
      }))();
    },
    toggle: function toggle(p) {
      this.$set(this.opened, p.plantNo, !this.opened[p.plantNo]);
      if (this.opened[p.plantNo] && !this.detail[p.plantNo]) this.loadDetail(p);
    },
    loadDetail: function loadDetail(p) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _yield$getAUOPlantInv, data;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.$set(_this2.detailLoading, p.plantNo, true);
                _this2.$set(_this2.detailError, p.plantNo, '');
                _context2.prev = 2;
                _context2.next = 5;
                return getAUOPlantInvertersApi(p.plantNo);
              case 5:
                _yield$getAUOPlantInv = _context2.sent;
                data = _yield$getAUOPlantInv.data;
                _this2.$set(_this2.detail, p.plantNo, data);
                _context2.next = 13;
                break;
              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](2);
                _this2.$set(_this2.detailError, p.plantNo, '逆變器資料讀取失敗，請洽資訊人員');
              case 13:
                _context2.prev = 13;
                _this2.$set(_this2.detailLoading, p.plantNo, false);
                return _context2.finish(13);
              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[2, 10, 13, 16]]);
      }))();
    },
    todayChart: function todayChart(p) {
      return {
        chart: {
          height: 180,
          spacing: [6, 4, 2, 0],
          backgroundColor: 'transparent'
        },
        title: {
          text: null
        },
        credits: {
          enabled: false
        },
        legend: {
          enabled: true,
          itemStyle: {
            fontSize: '11px'
          }
        },
        xAxis: {
          categories: p.curve.map(function (c) {
            return dayjs(c.t).format('HH:mm');
          }),
          tickInterval: Math.max(1, Math.round(p.curve.length / 8)),
          labels: {
            style: {
              fontSize: '10px'
            }
          }
        },
        yAxis: [{
          title: {
            text: null
          },
          labels: {
            style: {
              fontSize: '10px'
            }
          }
        }, {
          title: {
            text: null
          },
          opposite: true,
          labels: {
            style: {
              fontSize: '10px'
            }
          }
        }],
        tooltip: {
          shared: true,
          valueDecimals: 1
        },
        plotOptions: {
          series: {
            marker: {
              enabled: false
            }
          }
        },
        series: [{
          name: '發電功率 kW',
          type: 'area',
          data: p.curve.map(function (c) {
            return c.power;
          }),
          color: '#7cb5ec',
          fillOpacity: 0.25
        }, {
          name: '日照 W/m²',
          type: 'spline',
          yAxis: 1,
          data: p.curve.map(function (c) {
            return c.irradiance;
          }),
          color: '#f0ad4e'
        }]
      };
    },
    maxEnergy: function maxEnergy(inverters) {
      return Math.max.apply(Math, _toConsumableArray(inverters.map(function (i) {
        return i.energy || 0;
      })).concat([1]));
    },
    fmt: function fmt(v) {
      var digits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      return v == null ? '—' : Number(v).toFixed(digits);
    },
    pct: function pct(v, max) {
      if (!v || !max) return '0%';
      return "".concat(Math.min(100, v / max * 100).toFixed(1), "%");
    },
    prClass: function prClass(pr) {
      if (pr == null) return '';
      if (pr < 70) return 'is-fault';
      if (pr < 80) return 'is-warn';
      return 'is-ok';
    }
  },
  mounted: function mounted() {
    this.load();
  }
};